// extracted by mini-css-extract-plugin
export default {"RevenuesOtherSourceAddEditDialog":"styles_RevenuesOtherSourceAddEditDialog__+KYGO","container":"styles_container__LLIO5","row":"styles_row__LqEGC","item":"styles_item__3hW30"};